import { useCallback, useState } from "react";
import { customInstance } from "~/custom-instance";
import { trackEvent } from "~/utils/analytics";

interface FormatSectionResponse {
  formattedContent: string;
}

export const useFormatSection = (organizationId: string, sectionId: string) => {
  const [isFormatting, setIsFormatting] = useState(false);

  const formatSection = useCallback(
    async (content: string, instructions: string): Promise<string | null> => {
      if (!sectionId || !content) return null;

      setIsFormatting(true);

      try {
        const response = await customInstance<FormatSectionResponse>({
          url: `${import.meta.env.VITE_BASE_API_URL}/organizations/${organizationId}/custom-reports/reportSections/${sectionId}/format`,
          method: "POST",
          data: { content, instructions },
        });

        trackEvent({
          eventName: "app/report/section_format.success",
          properties: {
            sectionId,
            instructionsLength: instructions.length,
            hasCustomInstructions: instructions !== "Tidy up",
          },
        });

        return response.formattedContent;
      } catch (error) {
        trackEvent({
          eventName: "app/report/section_format.error",
          properties: {
            sectionId,
            error: error instanceof Error ? error.message : "Unknown error",
          },
        });
        throw error;
      } finally {
        setIsFormatting(false);
      }
    },
    [organizationId, sectionId]
  );

  return { formatSection, isFormatting };
};
